import API from "../../services/api";

// Get All Settings
export const getSettings = () =>
    API.get("/admin/settings");

// General
export const updateGeneralSettings = (data) =>
    API.put("/admin/settings/general", data);

// Business
export const updateBusinessSettings = (data) =>
    API.put("/admin/settings/business", data);

// Commission
export const updateCommissionSettings = (data) =>
    API.put("/admin/settings/commission", data);

// Delivery
export const updateDeliverySettings = (data) =>
    API.put("/admin/settings/delivery", data);

// Tax
export const updateTaxSettings = (data) =>
    API.put("/admin/settings/tax", data);

// Email
export const updateEmailSettings = (data) =>
    API.put("/admin/settings/email", data);

// SMS
export const updateSMSSettings = (data) =>
    API.put("/admin/settings/sms", data);

// Payment
export const updatePaymentSettings = (data) =>
    API.put("/admin/settings/payment", data);

// Branding
export const updateBrandingSettings = (data) =>
    API.put("/admin/settings/branding", data);

// Contact
export const updateContactSettings = (data) =>
    API.put("/admin/settings/contact", data);

// Social
export const updateSocialSettings = (data) =>
    API.put("/admin/settings/social", data);

// Security
export const updateSecuritySettings = (data) =>
    API.put("/admin/settings/security", data);

// Maintenance
export const updateMaintenanceSettings = (data) =>
    API.put("/admin/settings/maintenance", data);